export default "__VITE_ASSET__CrtKe9D6__"